export default __webpack_public_path__ + "static/media/gps.1d918210.gif";